/* eslint-disable no-magic-numbers */
import { IClientKey } from '~/providers/client-interfaces';
import { IAdminCatalogsFilter, IAdminKey, IAdminSearchProjectFilter } from '~/providers/admin-interfaces';
import { IInternalUser, IService, IUserState, ELoginState } from '~/providers/interfaces';

const ISO_TIME = new Date().toISOString();

export const REQUEST_TIMEOUT = 6000;
export const EMAIL_REQUEST_TIMEOUT = 30000;
export const UPLOAD_IMAGE_REQUEST_TIMEOUT = 30000;

export const MAX_USER_DESCIPTION_LEN = 200;
export const MAX_INT_DESCIPTION_LEN = 2000;
export const MAX_USER_NOTE_LEN = [5, 8192];
export const DEFAULT_MAX_PROJECT_COUNT = 5;

export const TRANSFER_VERSION = false;
export const ENABLE_USER_PROJECTS = true;
export const DISABLE_BILLING_TABLE = false;

export const DASHBOARD_KEYS_COUNT = 3;

export const ALL_LANGS = {
	czech: "cs",
	slovak: "sk",
	english: "en",
};

export const FALLBACK_LANG = ALL_LANGS.english;

// 20
export const MAX_USER_PROJECTS = 20;

// 20
export const MAX_USER_KEYS = 20;

export const TLD = window.daConfig.tld;

export const ROUTE_PARAMS = {
	PROJECT_ID: ":paramDetailId",
	KEY_ID: ":paramKeyId",
	PROJECT_INVITATION_ID: ":paramProjectInvitationId",
	WALLET_INVITATION_ID: ":paramWalletInvitationId",
};

export const CONSUMPTION_KEY = "consumption";

export const ROUTES = {
	// global
	TRANSFER: {
		path: `transfer`,
		test: null,
	},
	MY_PROJECTS: {
		path: `projects`,
		test: null,
	},
	TEST: {
		path: `test`,
		test: null,
	},
	PROJECT_INVITATION: {
		path: `invitation/project/${ROUTE_PARAMS.PROJECT_INVITATION_ID}`,
		test: /invitation\/project\/[a-z0-9-]+/u,
	},
	WALLET_INVITATION: {
		path: `invitation/wallet/${ROUTE_PARAMS.WALLET_INVITATION_ID}`,
		test: /invitation\/wallet\/[a-z0-9-]+/u,
	},
	// client project
	CLIENT_PROJECT_SETTINGS: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/settings`,
		test: /project\/\d+\/settings/u,
	},
	CLIENT_PROJECT_KEYS: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/keys`,
		test: /project\/\d+\/keys/u,
	},
	CLIENT_PROJECT_CONSUMPTION_HISTORY: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/consumption-history`,
		test: /project\/\d+\/consumption-history/u,
	},
	CLIENT_PROJECT_CONSUMPTION_DETAIL: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/consumption-detail`,
		test: /project\/\d+\/consumption-detail/u,
	},
	CLIENT_PROJECT_USERS: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/users`,
		test: /project\/\d+\/users/u,
	},
	CLIENT_PROJECT_FINANCIAL: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/financial`,
		test: /project\/\d+\/financial/u,
	},
	CLIENT_PROJECT_DASHBOARD: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/dashboard`,
		test: /project\/\d+\/dashboard/u,
	},
	CLIENT_PROJECT_CATALOG: {
		path: `project/${ROUTE_PARAMS.PROJECT_ID}/catalog`,
		test: /project\/\d+\/catalog/u,
	},
	// admin
	ADMIN_PROJECTS: {
		path: `admin-projects`,
		test: null,
	},
	ADMIN_USERS: {
		path: `admin-users`,
		test: null,
	},
	ADMIN_SERVICES: {
		path: `admin-services`,
		test: null,
	},
	ADMIN_TRANSACTIONS: {
		path: `admin-transactions`,
		test: null,
	},
	ADMIN_REPORTS: {
		path: `admin-reports`,
		test: null,
	},
	ADMIN_GRAPH_REPORTS: {
		path: `admin-graph-reports`,
		test: null,
	},
	ADMIN_BILLING_EXPORT: {
		path: `admin-billing-export`,
		test: null,
	},
	ADMIN_CATALOGS: {
		path: `admin-catalogs`,
		test: null,
	},
	ADMIN_QUICK_COMMENT: {
		path: `admin-quick-comment`,
		test: null,
	},
	ADMIN_API_USERS: {
		path: `admin-api-users`,
		test: null,
	},
	// admin project
	ADMIN_PROJECT_SETTINGS: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/settings`,
		test: /admin\/project\/\d+\/settings/u,
	},
	ADMIN_PROJECT_KEYS: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/keys`,
		test: /admin\/project\/\d+\/keys/u,
	},
	ADMIN_PROJECT_CONSUMPTION_HISTORY: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/consumption-history`,
		test: /admin\/project\/\d+\/consumption-history/u,
	},
	ADMIN_PROJECT_CONSUMPTION_DETAIL: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/consumption-detail`,
		test: /admin\/project\/\d+\/consumption-detail/u,
	},
	ADMIN_PROJECT_USERS: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/users`,
		test: /admin\/project\/\d+\/users/u,
	},
	ADMIN_PROJECT_FINANCIAL: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/financial`,
		test: /admin\/project\/\d+\/financial/u,
	},
	ADMIN_PROJECT_DASHBOARD: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/dashboard`,
		test: /admin\/project\/\d+\/dashboard/u,
	},
	ADMIN_PROJECT_JOURNAL: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/journal`,
		test: /admin\/project\/\d+\/journal/u,
	},
	ADMIN_PROJECT_NOTIFICATIONS: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/notifications`,
		test: /admin\/project\/\d+\/notifications/u,
	},
	ADMIN_PROJECT_BUSINESS: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/business`,
		test: /admin\/project\/\d+\/business/u,
	},
	ADMIN_PROJECT_CATALOG: {
		path: `admin/project/${ROUTE_PARAMS.PROJECT_ID}/catalog`,
		test: /admin\/project\/\d+\/catalog/u,
	},
};

export const BASENAME_PATH = "/account/";

export const KEYS = {
	ESC: "Escape",
	LEFT: "ArrowLeft",
	RIGHT: "ArrowRight",
	UP: "ArrowUp",
	DOWN: "ArrowDown",
	ENTER: "Enter",
};

export const FOOTER_LINKS = {
	SEZNAM: "https://www.seznam.cz",
	HELP: "https://www.seznam.cz",
	RULES: "https://www.seznam.cz",
	CONTACT: "https://www.seznam.cz",
};

export const DOCUMENTATION_MENU_LINK = "https://developer.mapy.cz/portal-muj-ucet/";
export const DOCUMENTATION_LINK = "https://developer.mapy.cz/portal-muj-ucet/projekty-a-api-klice/";
export const DOCUMENTATION_ATTR_LINK = "https://developer.mapy.cz/rest-api/atributovani/";
export const CREATE_WALLET_LINK = "https://klient.seznam.cz/wallet/";
export const PRICE_LIST_LINK = "https://developer.mapy.cz/cena";
export const CONTACT_LINK = "https://developer.mapy.cz/kontakt/";
export const WALLET_REGISTER = {
	cs: CREATE_WALLET_LINK,
	en: "https://klient.seznam.cz/wallet?language=en",
};
export const WALLET_DOCUMENTATION = {
	cs: "https://developer.mapy.cz/portal-muj-ucet/financni-nastaveni/jak-zapnout-placenou-spotrebu/",
	en: "https://developer.mapy.cz/en/my-account/financial-settings/how-to-turn-on-paid-consumption/",
};
export const LICENCE_AGGR = {
	cs: "https://developer.mapy.cz/smluvni-ujednani/",
	en: "https://developer.mapy.cz/en/terms-and-conditions/",
};
export const CREATE_PROJECT_INFO_LINKS = {
	cs: "https://developer.mapy.cz/portal-muj-ucet/projekty-a-api-klice/",
	en: "https://developer.mapy.cz/en/my-account/project-and-api-keys/",
};
export const CATALOG_LINKS = {
	cs: "https://developer.mapy.cz/portal-muj-ucet/katalog-projektu/",
	en: "https://developer.mapy.cz/en/my-account/project-catalog/",
};

export const SMALL_MEDIA_QUERY = "(max-width: 768px)";

export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTS = [10, 25, 50, 100];
export const PAGE_SIZE_ADMIN_PROJECTS = 100;
export const PAGE_SIZE_ADMIN_CATALOGS = 100;

export const MIN_STRING_LENGTH = 3;

export const MY_LIST_COUNT = 5;

export const EMAIL_PLACEHOLDER = "email@seznam.cz";

export const EMAIL = "roman.makudera@firma.seznam.cz";

export const API_PATH = {
	CLIENT: `${BASENAME_PATH}api/v1/client`,
	ADMIN: `${BASENAME_PATH}api/v1/admin`,
};

export const FETCH_DEF_ERROR = 555;

/* ************* prazdna data ************************** */
export const USER_STATE: IUserState = {
	name: "",
	email: "",
	rusId: 0,
	state: ELoginState.Red,
	avatar: "",
	publicId: "",
	internalRole: "none",
	isInternal: false,
	hasProjects: false,
	userLanguage: FALLBACK_LANG,
};

export const CLIENT_API_KEY: IClientKey = {
	id: 0,
	internalName: "",
	apiKey: "",
	userTitle: "",
	userDescription: "",
	restrictions: {},
	createdAt: ISO_TIME,
	userSwitch: true,
	canConsume: true,
	forbiddenConsumptionReason: "",
};

export const ADMIN_API_KEY: IAdminKey = {
	...CLIENT_API_KEY,
	internalDescription: "",
	internalName: "",
};

export const ADMIN_SERVICE: IService = {
	id: 0,
	service: "",
	callPrice: 5,
	hiddenForUsers: false,
	regularService: true,
	rootServiceId: null,
	serviceType: "ENDPOINT",
};

export const ADMIN_INTERNAL_USER: IInternalUser = {
	id: 0,
	email: "",
	createdAt: ISO_TIME,
	internalRole: "salesman",
	source: "rus",
};

export const NEW_KEY_NAME = "Výchozí API klíč";

export const KEY_PREVIEW_LENGTH = 16;
export const KEY_DETAIL_LENGTH = 64;

export const MAX_YEAR = 2100;

export const SEMAPHORE_CONSUMPTION = 30;

export const PENNY_KC_RATIO = 100;

export const PRICE_CREDIT_RATIO = 1000;

export const JOURNAL_ITEMS_COUNT = 2;

export const ADMIN_PROJECTS_SORT_KEYS: Array<keyof IAdminSearchProjectFilter> = [
	"sortByInternalName",
	"sortByCanConsume",
	"sortByBusinessPlanType",
	"sortByBilledConsumption",
	"sortByCurrentMonthConsumption",
	"sortByPreviousMonthConsumption",
	"sortByLastConsumptionDate",
	"sortByCurrentMonthAmountBilled",
	"sortByPreviousMonthAmountBilled",
];

export const ADMIN_CATALOGS_SORT_KEYS: Array<keyof IAdminCatalogsFilter> = [
	"sortByApproved",
	"sortByInternalName",
	"sortByLastUpdate",
	"sortByPreviousMonthConsumption",
	"sortByPublished",
	"sortByQuality",
];

export const ADMIN_PROJECTS_FILTER_NAMING: Array<[keyof IAdminSearchProjectFilter, string]> = [
	["billedConsumption", "bc"],
	["billingMethod", "bm"],
	["businessPlanType", "bpt"],
	["canConsume", "cc"],
	["keyword", "kw"],
	["offset", "of"],
	["sortByBilledConsumption", "sbbc"],
	["sortByBusinessPlanType", "sbbpt"],
	["sortByCanConsume", "sbcc"],
	["sortByCurrentMonthConsumption", "sbcmc"],
	["sortByInternalName", "sbin"],
	["sortByLastConsumptionDate", "sblcd"],
	["sortByPreviousMonthConsumption", "sbpmc"],
	["limit", "lm"],
	["vip0", "vip0"],
	["approvedAdvancedPlan", "aap"],
	["actionRequired", "acr"],
	["archived", "arc"],
];

export const DEFAULT_BUSSINESS_PLAN_TYPE_FILTER = "basic,advanced,vip";

export const MAX_CATALOG_IMAGES = 5;

export const DEFAULT_UPLOAD_PREVIEW_SIZE = 200;

export const PREVIEW_MAX_FILE_SIZE_MB = 10;
export const PREVIEW_MIN_SIZE = 500;
export const PREVIEW_MAX_SIZE = 4000;

// pak smazat az bude vse cajk todor
export const MESSAGE = `
	sebastian.balna@seznam.dev.dszn.cz
	asddsa
	jan.las@firma.seznam.cz
	bb
	tomas.cvrk@firma.seznam.cz
	apikey=qdwN_-Lx_Um-wBAcgcX4aDCcZ7s8bTylEFTJTz1xYZc
	apikey=qdwN_-Lx_Um-wBAcgcX4aDCcZ7s8bTylEFTJTz1xadd
Id Projektu/API klíče
 	GtSPdLHt2dJ4nzYsllf_hgI9lydu6D7qT1GEPBmdJfk
Id Projektu/API klíče
 	roman-test5:Key-01
Váš dotaz k API Mapy.cz
 	Dobrý den, v mé emailové s
Telefon
 	+420724577190
Id Projektu/API klíče
 	HZPnEfKkmcTdWHHhNq8y097rubpjlffQ4Q0CywfyWl8
 	x2WWFup70Yaa-geD_YSqBchAycPMyomyZMC_9wjK6YU
 	QeDbPgTixNFVNP6Ji181q6zcyH5KwedZSVzdlwnT7Mg
Váš dotaz k API Mapy.cz
 	Dobrý den,

jako příspěvková organizace Ministerstva životního prostředí provozujeme dle zákona č. 365/2000 Sb., o informačních systémech veřejné správy informační systém veřejné správy - jedná se o Centrální registr životního prostředí (CRŽP) - www.crzp.cz. Správcem dle výše uvedeného zákona je Ministerstvo životního prostředí.
V rámci systému jeho uživatelé (povinné subjekty a pracovníci veřejné správy) pracují s registrem provozoven (ovzduší a IRZ) - pro zobrazení konkrétní provozovny jsou využívány mapové podklady mapy.cz
`;

export const BLACK_LIST_EMAILS = [
	"jan.las@firma.seznam.cz",
	"tomas.cvrk@firma.seznam.cz",
];
